import request from "@/utils/request";

// 积分排行
export function integralRank(params) {
  return request({
    url: "/myDonate/integralRank",
    method: "get",
    params,
  });
}

// 需求列表（捐衣、捐物）
export function listDemand(params) {
  return request({
    url: "/myDonate/listDemand",
    method: "get",
    params,
  });
}

// 需求详情
export function demandDetail(params) {
  return request({
    url: "/myDonate/demandDetail",
    method: "get",
    params,
  });
}

// 快捷捐衣
export function fastClothes(params) {
  return request({
    url: "/myDonate/fastClothes",
    method: "get",
    params,
  });
}

// 快捷捐物
export function fastGoods() {
  return request({
    url: "/myDonate/fastGoods",
    method: "get",
  });
}

// 快捷捐物列表
export function list(params) {
  return request({
    url: "/myDonate/fastGoods/list",
    method: "get",
    params,
  });
}

// 取消捐赠
export function cancelDonate(data) {
  return request({
    url: "/myDonate/cancelDonate",
    method: "post",
    data,
  });
}

// 可捐衣物登记/捐赠篮提交
export function fastDonate(data) {
  return request({
    url: "/myDonate/fastDonate",
    method: "post",
    data,
  });
}
// 送货上门邮寄方式
export function doorMail(params) {
  return request({
    url: '/myDonate/doorMail',
    method: 'post',
    params
  })
}

// 我的捐赠
export function myDonateList(params){
  return request({
    url:'/myDonate/myDonate',
    method:'get',
    params
  })
}

// 历年项目
export function historyProject(params){
  return request({
    url:'/myDonate/historyProject',
    method:'get',
    params
  })
}

// 捐赠详情
export function donateDetail(params) {
  return request({
    url: '/myDonate/getDetailByNumber',
    method: 'get',
    params
  })
}
// 查询邮寄方式、物流信息
export function getExpressInfoApi(params) {
  return request({
    url: '/myDonate/getExpressInfo',
    method: 'GET',
    params
  })
}

// 修改邮寄方式
export function changeExpressInfoApi(data) {
  return request({
    url: '/myDonate/changeExpressInfo',
    method: 'post',
    data
  })
}
